import { DeleteOutline, EditOutlined, MoreHoriz } from '@mui/icons-material';
import { IconButton, MenuItem, Popover, Tooltip, Typography } from '@mui/material';
import { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useTheme } from '@mui/material/styles';
import { getNightOrDayPalette } from '../../utils/getNightOrDayPalette';

type Props = Readonly<{
	openEdit: () => void;
	onDelete?: () => void;
	deleteDisabledMessage?: string;
}>;

export const CustomTableActions: FC<Props> = ({ openEdit, onDelete, deleteDisabledMessage }) => {
	const theme = useTheme();
	const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
	const open = Boolean(anchorEl);
	const id = open ? 'simple-popover' : undefined;

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const handleOpenEdit = () => {
		setAnchorEl(null);
		openEdit();
	};
	const handleDelete = () => {
		setAnchorEl(null);
		onDelete?.();
	};

	return (
		<>
			<IconButton onClick={handleClick}>
				<MoreHoriz />
			</IconButton>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
			>
				<MenuItem onClick={handleOpenEdit} sx={{ gap: 1 }}>
					<EditOutlined sx={{ fontSize: 18, fill: theme.palette[getNightOrDayPalette(theme)][500] }} />
					<Typography variant={'body1'}>
						<FormattedMessage id={'common.edit'} />
					</Typography>
				</MenuItem>
				{(onDelete != null || deleteDisabledMessage != null) && (
					<Tooltip title={deleteDisabledMessage}>
						<span>
							<MenuItem onClick={handleDelete} sx={{ gap: 1 }} disabled={deleteDisabledMessage != null}>
								<DeleteOutline sx={{ fontSize: 18, fill: theme.palette[getNightOrDayPalette(theme)][500] }} />
								<Typography variant={'body1'}>
									<FormattedMessage id={'common.delete'} />
								</Typography>
							</MenuItem>
						</span>
					</Tooltip>
				)}
			</Popover>
		</>
	);
};
